import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import {
  showAddClient as selectShowAddClient,
  showCampaignsSelector as selectShowCampaigns,
  showDashboard as selectShowDashboard,
  showLeads as selectShowLeads,
  showClientsList as selectShowClientList,
} from '../../../AdviserArea/AdviserAreaSelector';
import { Feature } from '../../../CommonSelectors/CommonArea.types';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Wrapper } from './Navigation.styles';
import { AddClientModal } from '../../../AddClientModal/AddClientModal';


interface Props {
  onClientListClick(): void;
}

export const Navigation: React.FC<Props> = ({ onClientListClick }) => {
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);

  const showDashboard = useSelector(selectShowDashboard);
  const showAddClient = useSelector(selectShowAddClient);
  const showLeads = useSelector(selectShowLeads);
  const showCampaigns = useSelector(selectShowCampaigns);
  const showClientList = useSelector(selectShowClientList);
  const isPdfImportEnabled = useFeatureFlag(Feature.EnablePdfImport);

  return (
    <>
      <Wrapper as="nav">
        {showClientList && (
          <Button variant="subtleInactive" leftIcon="far fa-list-alt" onClick={onClientListClick}>
            Client List
          </Button>
        )}

        {showDashboard && (
          <Button
            variant="subtleInactive"
            leftIcon="far fa-th-large"
            onClick={() => ADV.util.Router.go2('Dashboard')}
          >
            Dashboard
          </Button>
        )}

        {showAddClient && (
          <Button
            variant="subtleInactive"
            leftIcon="far fa-user-plus"
            onClick={() => setIsAddClientModalOpen(true)}
          >
            Add Client
          </Button>
        )}

        {showAddClient && isPdfImportEnabled && (
          <Button
            variant="subtleInactive"
            leftIcon="far fa-file-pdf"
            onClick={() => ADV.util.Router.go2('PdfImport')}
          >
            Import Plans
          </Button>
        )}

        {showLeads && (
          <Button
            variant="subtleInactive"
            leftIcon="far fa-filter"
            onClick={() => ADV.util.Router.go2('Leads')}
          >
            Leads
          </Button>
        )}

        {showCampaigns && (
          <Button
            variant="subtleInactive"
            leftIcon="far fa-envelope"
            onClick={() => ADV.util.Router.go2('Campaigns')}
          >
            Campaigns
          </Button>
        )}
      </Wrapper>

      {isAddClientModalOpen && <AddClientModal onClose={() => setIsAddClientModalOpen(false)} />}
    </>
  );
};
